module.exports = __webpack_public_path__ + "static/img/indexLogo.30c70ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indexLogo.png
// module id = L6Q4
// module chunks = 12